export class ProductUUID 
{
    static NAMIRASOFT_ACCESS = "prd-c7836310e7e54170";
    static NAMIRASOFT_ACCOUNT = "prd-a376a409dabe4b4b";
    static NAMIRASOFT_ALARM = "prd-ad236da9ae8d4e7f";
    static NAMIRASOFT_BALANCE = "prd-c7a4983e15524686";
    static NAMIRASOFT_BILL_WATCH = "prd-237ccb143fb04e52";
    static NAMIRASOFT_CERTIFICATE_MANAGER = "prd-b80264f9099d4397";
    static NAMIRASOFT_CODE_VERIFY = "prd-5bdec5c48f3c42b4";
    static NAMIRASOFT_CONTENT_TEMPLATE = "prd-b1360c432dc04a27";
    static NAMIRASOFT_COST = "prd-bd9199b941c445bf";
    static NAMIRASOFT_CREDENTIAL = "prd-986059d99192405b";
    static NAMIRASOFT_DATA = "prd-343eedc9a5644124";
    static NAMIRASOFT_DONATE = "prd-47eeb1a3b82645c7";
    static NAMIRASOFT_EARN = "prd-833364ab98e541a0";
    static NAMIRASOFT_EMAIL_SENDER = "prd-464a57e70bbf4fff";
    static NAMIRASOFT_FIELD = "prd-a9fb78ad0b6e4cd3";
    static NAMIRASOFT_FILE_SYSTEM = "prd-3b0efb7acb974f91";
    static NAMIRASOFT_GITLAB = "prd-63b59fc75a05466b";
    static NAMIRASOFT_HISTORY = "prd-10bb85099e6f4c0a";
    static NAMIRASOFT_HIVE = "prd-9ae665e23fab4314";
    static NAMIRASOFT_JOB_ARRANGER = "prd-23e6a126ab4e4627";
    static NAMIRASOFT_LEND = "prd-9755bedbd7454017";
    static NAMIRASOFT_LINK = "prd-5720921162124815";
    static NAMIRASOFT_LOG = "prd-d0388150e7054a43";
    static NAMIRASOFT_MESSAGE = "prd-17241f2d8d264b01";
    static NAMIRASOFT_MONITOR = "prd-bb35ddc3cd3b4c81";
    static NAMIRASOFT_MYSQL = "prd-906eba1a4aa94436";
    static NAMIRASOFT_NEWS = "prd-6aad410d6ec44823";
    static NAMIRASOFT_NEXUS_CLEANER = "prd-b4f2a736f9934d30";
    static NAMIRASOFT_NOTIFICATION_SENDER = "prd-1d12a9e6eb5f411a";
    static NAMIRASOFT_NWS_GITLAB_BACKUP = "prd-7d4cdc5785674bc0";
    static NAMIRASOFT_NWS_MAX_MIND = "prd-d7f8af3103344c9d";
    static NAMIRASOFT_NWS_OLLAMA = "prd-a6f8aeaf1bc4462a";
    static NAMIRASOFT_NWS_REGION = "prd-e73d2a024fb44b4e";
    static NAMIRASOFT_PAYMENT = "prd-f66a2ebf57f149e4";
    static NAMIRASOFT_PHPMYADMIN = "prd-59946c6407a74162";
    static NAMIRASOFT_PLAY = "prd-4ba43bec6b964e74";
    static NAMIRASOFT_POSITION = "prd-8670e24783c343e0";
    static NAMIRASOFT_PRODUCT = "prd-62ad582bb6034386";
    static NAMIRASOFT_RABBITMQ = "prd-7ee68c24fc7d4abd";
    static NAMIRASOFT_RABBITMQ_ENDPOINT = "prd-8a12a7949d42426c";
    static NAMIRASOFT_REDEEM = "prd-40374ef2751c4051";
    static NAMIRASOFT_REDMINE = "prd-b0067003a1904274";
    static NAMIRASOFT_SECRET = "prd-84a5484d86bd4c11";
    static NAMIRASOFT_SERVICE = "prd-2f6d57404fb94d52";
    static NAMIRASOFT_SLACK_SENDER = "prd-98cb36cd29644ee8";
    static NAMIRASOFT_SMS_SENDER = "prd-d62033a2923643db";
    static NAMIRASOFT_STATIC = "prd-031d1a9594174c1e";
    static NAMIRASOFT_SUPPORT = "prd-5a0d9558f84b470a";
    static NAMIRASOFT_TEAMS_SENDER = "prd-ff768658f9bc46a7";
    static NAMIRASOFT_TELEGRAM_SENDER = "prd-7d9bb421a3fd467d";
    static NAMIRASOFT_TIMIFY = "prd-1c42a8919de247a8";
    static NAMIRASOFT_WORK = "prd-0e40f7c87ad14966";
    static NAMIRASOFT_WORKSPACE = "prd-a365c9a5db434a23";
};